import React from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import Cookies from "js-cookie";
import Layout from "../Layout/Layout";
import {  Admin, Dashboard, FolderDetails, Login, SharableFolder, Temp, } from "../Pages/Exports";
import NotFound from "../Pages/NotFound";
import LayoutPage from "../Layout/Layouts/Layout";


const isAuthenticated = () => {
  const accessToken = Cookies.get("access_token");
  return accessToken ? true : false;
};

// Check if the user is an admin
const isAdmin = () => {
  return Cookies.get("user_type") === "admin";
};


// Protected Route Component to manage authentication and role-based access
const ProtectedRoute = ({ component, componentType }: any) => {
  const isAuth = isAuthenticated();
  const userIsAdmin = isAdmin();

  if (isAuth) {

    if (componentType === "login" && userIsAdmin) {
      return <Navigate to="/admin" replace />;
    }

    if (userIsAdmin) {
      return component;
    }

    return <Navigate to="/admin" replace />;
  } else {
    // User is not authenticated
    Cookies.remove("access_token");
    Cookies.remove("user_type");
    localStorage.clear();
    if (componentType === "login") {
      return component;
    } else {
      return <Navigate to="/login" replace />;
    }
  }
};



const router = createBrowserRouter([
  {
    path: "/",
    element: <Navigate to="/folders" replace />,
    errorElement: <NotFound />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  
  {
    element: <Layout />,
    children: [
      {
        path: "/admin",
        element: <ProtectedRoute componentType={"admin_dashboard"} component={<Admin />} />,
      },

      {
        path: "/folder/:id",
        element: <ProtectedRoute componentType={"admin_dashboard"} component={<FolderDetails />} />,
      },

      {
        path : "/temp",
        element : <Temp />
      }
    ],
  },
  {
    element: <LayoutPage />,
    children: [
      {
        path: "/folders",
        element: <Dashboard />,
      },
      {
        path: "/folders/:id",
        element: <SharableFolder />,
      },
    ],
  },

  {
    path: "*",
    element: <NotFound />,
  },
]);

export default router;
